import { Component, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { EventEmitterService } from '../../services/event-emitter.service';

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  @Input() tabs = [];
  @Input() bottomTabs = [];
  @Input() selectedTab;
  isExpanded = true;

  constructor(
    private router: Router,
    public eventEmitterService: EventEmitterService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.setExpanded();
  }

  goToRoute(route) {
    if (route == 'logout') {
      this.showLogoutPopup();
    } else if (route == 'expand') {
      this.toggleSidebar();
    } else {
      this.router.navigate([route]);
    }
    this.closeSidebar();
  }

  showLogoutPopup() {
    this.authenticationService.logout();
  }

  closeSidebar() {
    this.eventEmitterService.setShowSidebar(false);
  }

  setExpanded() {
    this.isExpanded = JSON.parse(localStorage.getItem('isExpanded') || 'true');
  }

  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
    localStorage.setItem('isExpanded', this.isExpanded + '');
  }
}
